import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32689ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DeliveryPanelInformation" }
const _hoisted_2 = { class: "DeliveryPanelInformation__content mt-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 select-none" }, "№ Накладной", -1))
const _hoisted_5 = { class: "py-2 px-4 border border-gray-200 rounded mt-1" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 select-none" }, "Клиент", -1))
const _hoisted_9 = { class: "py-2 px-4 border border-gray-200 rounded mt-1" }
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 select-none" }, "Адрес", -1))
const _hoisted_13 = { class: "py-2 px-4 border border-gray-200 rounded mt-1" }
const _hoisted_14 = { class: "font-medium" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 select-none" }, "Курьер", -1))
const _hoisted_17 = { class: "py-2 px-4 border border-gray-200 rounded mt-1" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 select-none" }, "Доставлено в", -1))
const _hoisted_21 = { class: "py-2 px-4 border border-gray-200 rounded mt-1" }
const _hoisted_22 = { class: "font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.order.status)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.order.status.title), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.order.invoiceNumber), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.order.companyName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            (_ctx.order.customer)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.order.customer.address), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            (_ctx.order.courier)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.order.courier.fullName), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, [
            (_ctx.order.deliveredAt)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.order.deliveredAt), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ])
        ])
      ])
    ])
  ]))
}